module.exports = "/packs/media/modules/shared/components/fs/react-telephone-input-flags-5bc53ca7a4007fdb12039bbe4990a7f1.png";